import React from 'react';
import API from 'src/api/api';
import { Container, useMediaQuery } from '@material-ui/core';
import LoadingContainer from 'src/components/LoadingContainer/LoadingContainer';
import NoBillingImg from 'src/assets/icons/nobilling-bg.png';
import { t } from 'src/i18n';
import { useStyles } from './Billing.style';
import { all, compose, pathOr, values } from 'ramda';

const BillingView: React.FC = () => {
  const [iframeSource, setIframeSource] = React.useState<string>('');
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [billingApiFailed, setBillingApiFailed] = React.useState<boolean>(
    false
  );
  const classes = useStyles();

  const getIframeSource = async () => {
    try {
      const checkBillingStatus = await API().get('/payment/v1/account/status');
      const isShowBilling = compose(
        all(item => !!item),
        values,
        pathOr({}, ['data'])
      )(checkBillingStatus);
      if (isShowBilling) {
        const response = await API().get('/payment/v1/patient/signon');
        setIframeSource(response.data.signonUrl);
        setIsLoading(false);
      } else {
        setBillingApiFailed(true);
        setIsLoading(false);
      }
    } catch (error) {
      setBillingApiFailed(true);
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    getIframeSource();
  }, []);


  const matches = useMediaQuery('(max-width:768px)');
  const isIpadLg = useMediaQuery('(max-width:1024px)');
  const isTablet = matches || isIpadLg;

  return (
    <LoadingContainer isLoading={isLoading}>
      <>
        {billingApiFailed ? (
          <Container style={{ textAlign: 'center', marginTop: 10 }}>
            <p className={classes.message}>{t('dashboard.userBalance.noBilling')}</p>
            <img src={NoBillingImg} alt="Logo" style={isTablet ? { width: '600px', maxHeight: '491px' } : { height: '491px' }} />
          </Container>
        ) : <Container>
            <iframe
              src={iframeSource}
              title="Billing"
              width="100%"
              height={`${window.innerHeight * 0.92}`}
              style={{ marginTop: '10px' }}
            />
          </Container>
        }
      </>
    </LoadingContainer>
  );
};

export default BillingView;
